import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
  imageDesktop,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: true,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        overflow: hidden;
        padding-bottom: 50px;
        padding-top: 50px;
      `,
      tabletWrapperStyles: css`
        padding-bottom: 60px;
        padding-top: 40px;
      `,
      desktopWrapperStyles: css`
        padding-bottom: 180px;
        padding-top: 140px;
      `,
    },
    containerProps: {
      mobileContainerStyles: null,
      tabletContainerStyles: css`
        flex-direction: column;
        justify-content: flex-start;
      `,
      desktopContainerStyles: css`
        flex-direction: row;
        justify-content: space-between;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      mobileContainerStyles: css`
        padding: 0 30px;
        button {
          margin-top: 35px;
        }
      `,
      tabletContainerStyles: css`
        h1 {
          max-width: 400px;
          text-align: left;
        }
        p {
          text-align: left;
        }
        button {
          margin-left: 0;
        }
        & > div {
          max-width: 600px;
        }
      `,
      desktopContainerStyles: css`
        max-width: 680px;
        h1 {
          margin-left: 0;
          margin-right: 0;
          max-width: none;
        }
        p {
          font-size: 2.2rem;
        }
        & > div {
          max-width: none;
        }
        min-width: none;
      `,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      imageDesktop: imageDesktop,
      mobileImageWrapperStyles: css`
        margin-top: 65px;
        video {
          display: block;
          margin: 0 auto;
          width: 80%;
        }
      `,
      tabletImageWrapperStyles: css`
        align-items: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 100px;
        video {
          width: 70%;
        }
      `,
      desktopImageWrapperStyles: css`
        margin-top: 0;
        width: 49%;
        video {
          width: 100%;
        }
      `,
      mobileImageStyles: null,
      tabletImageStyles: css`
        margin-left: 0;
        width: auto;
      `,
    },
  }
}
